import {Component, EventEmitter, Input, OnDestroy, OnInit, Output,} from '@angular/core';
import {GalleriaModule} from 'primeng/galleria';
import {NgIf} from '@angular/common';
import {PrimeTemplate} from 'primeng/api';
import {SharedModule} from '../../shared.module';
import {ProyectoService} from '../../../users/proyectos/services/proyecto.service';
import {TramiteService} from '../../../users/tramites/services/tramite.service';
import {LoginServices} from '../../../auth/login/services/login.service';
import {ViewerInterface} from '../../interfaces/viewer-interface';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {Observable, of, shareReplay} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Component({
    selector: 'app-viewer-img',
    standalone: true,
    imports: [GalleriaModule, NgIf, PrimeTemplate, SharedModule],
    templateUrl: './viewer-img.component.html',
    styleUrls: ['./viewer-img.component.scss'],
})
export class ViewerImgComponent implements OnInit, OnDestroy {
    @Input() _showLoader: boolean = false;
    @Input() _displayImgView: boolean = false;
    @Input() viewer!: ViewerInterface;
    @Output() onImgtEmitterClose = new EventEmitter<boolean>();

    images: Array<{
        name: string;
        src: string;
        blobUrl?: Observable<SafeUrl | null>;
    }> = [];
    validImage: boolean = false;
    private objectUrlCache = new Map<string, string>();

    constructor(
        private proyectoServices: ProyectoService,
        public tramite: TramiteService,
        public loginServices: LoginServices,
        private sanitizer: DomSanitizer,
        private http: HttpClient
    ) {
    }

    ngOnInit(): void {
        this.openFileInViewer(this.viewer.hash!, this.viewer.nombre!);
    }

    ngOnDestroy(): void {
        this.objectUrlCache.forEach((objectUrl) => {
            URL.revokeObjectURL(objectUrl);
        });
        this.objectUrlCache.clear();
    }

    /**
     * Abre y “firma” un único archivo de imagen.
     * — Agrega un nuevo item a this.images
     * — Si ya existe en cache, no hace petición; usa el objectUrl almacenado.
     * — Si no existe, lo descarga y genera un objectUrl.
     */
    openFileInViewer(hash: string, fileName: string) {
        const rawUrl = new URL(
            this.proyectoServices.getSrcFile(hash, 'inline')
        ).toString();

        const dataImg: { name: string; src: string; blobUrl?: Observable<SafeUrl | null> } = {
            name: fileName,
            src: rawUrl,
        };

        this.images.push(dataImg);
        if (this.objectUrlCache.has(rawUrl)) {
            const cachedUrl = this.objectUrlCache.get(rawUrl)!;
            const safe = this.sanitizer.bypassSecurityTrustUrl(cachedUrl);
            dataImg.blobUrl = of(safe);
        } else {
            dataImg.blobUrl = this.http
                .get(rawUrl, {responseType: 'blob'})
                .pipe(
                    map((blob: Blob) => {
                        const objectUrl = URL.createObjectURL(blob);
                        this.objectUrlCache.set(rawUrl, objectUrl);
                        return this.sanitizer.bypassSecurityTrustUrl(objectUrl);
                    }),
                    catchError(() => {
                        return of(null);
                    }),
                    shareReplay(1)
                );
        }

        this._showLoader = true;
        this.displayImgView = true;
    }

    imageLoaded(event: any) {
        if (event.type === 'load' && this.images.length > 0) {
            this._showLoader = false;
            this.validImage = true;
            console.log('Imagen cargada correctamente');
        }
        if (event.type === 'error') {
            this._showLoader = false;
            this.validImage = false;
            console.log('Error: la imagen no se cargó');
        }
    }

    get displayImgView(): boolean {
        return this._displayImgView;
    }

    set displayImgView(value: boolean) {
        this._displayImgView = value;
        if (!value) {
            this.images = [];
            this.onImgtEmitterClose.emit(false);
        }
    }
}
